import React from "react";
import { Link } from "react-router-dom";
import { EXTERNAL_URLS, BUTTON_TEXT } from "../constants";

const Contact = React.memo(() => {
	return (
		<section id='Contact' className='py-40 bg-transparent sm:py-40' aria-labelledby='contact-heading'>
			<div className='mx-auto max-w-7xl px-4 lg:px-16'>
				<header className='text-center max-w-2xl mx-auto'>
					<h2 id='contact-heading' className='text-3xl font-bold tracking-tight leading-10 text-gray-900 sm:text-6xl'>
						Keep in touch with me <br />
						<span className='block mt-4 leading-10'>Say Hi!</span>
					</h2>
				</header>

				<nav className='mt-16 flex justify-center gap-x-6' aria-label='Contact options'>
					<Link
						to={EXTERNAL_URLS.WHATSAPP}
						target='_blank'
						rel='noopener noreferrer'
						className='bg-gray-900 px-7 py-4 text-sm font-bold tracking-wide text-white shadow-sm hover:bg-transparent hover:border-gray-900 hover:text-gray-900 border-2 border-gray-900 hover:shadow-md focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600'
						aria-label='Start a conversation on WhatsApp'>
						{BUTTON_TEXT.START_CONVERSATION}
					</Link>
				</nav>
			</div>
		</section>
	);
});

Contact.displayName = 'Contact';

export default Contact;
